<template lang='pug'>
.mainWrapper-innerContent
  .mainWrapper-leftContent
    BreadCrumb(:breadcrumbList='breadcrumbs' normal)
    MediaBlock(:staticData='data.media')
  .mainWrapper-rightContent
    .sidebar--right(class='show--bigScreens')
      StatisticsBlock(:title='data.statistics.title' :items='data.statistics.data' :subText='data.statistics.subText' type='today')
      LatestArticlesBlock(
        :title='data.latestArticles.title'
        type="latest"
        :params='params'
        :staticData='data.latestArticles'
      )
</template>
<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue'
import MediaBlock from '@/components/media/media_block.vue'
import StatisticsBlock from '@/components/statistics/statistics_block.vue'
import LatestArticlesBlock from '@/components/latest_articles/latest_articles_block.vue'

export default {
  components: {
    BreadCrumb,
    MediaBlock,
    StatisticsBlock,
    LatestArticlesBlock
  },
  props: {
    data: Object,
    breadcrumbList: Array
  },
  data() {
    return {
      params: {
        "size": 5,
        "sort": {
          "updatedAt": {
            "dir": "desc",
            "default": true
          }
        }
      },
      breadcrumbs: JSON.parse(JSON.stringify(this.breadcrumbList))
    }
  },
  created() {
    this.breadcrumbs.push({
      text: '媒體識讀',
      link: '/media'
    })
  }
}
</script>
